import fetcher from '../utils/api';

const scribeDocumentService = {
  listGallery: async ({ tagSlugs, skip, get_first }) => {
    const additionalParams = [];

    if (tagSlugs && tagSlugs.length > 0) {
      additionalParams.push(`q=${encodeURIComponent(tagSlugs.join(','))}`);
    }
    if (skip !== undefined && skip !== null) {
      additionalParams.push(`skip=${encodeURIComponent(skip)}`);
    }

    if (get_first !== undefined && get_first !== null) {
      additionalParams.push(`get_first=${encodeURIComponent(get_first)}`);
    }

    return fetcher('gallery/' + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`);
  },
  listWorkspaceWithFolders: async ({
    fileSearchQuery,
    fileInFolderQuery,
    sortByQuery,
    getFirstQuery,
    hasFolder,
    authenticated = true,
    filterTags,
    filterScribes,
    processTagFilter,
    skip,
    aggregateBy
  }) => {
    const additionalParams = [];
    // file name query

    if (fileSearchQuery && fileSearchQuery.trim().length > 1) {
      additionalParams.push(`q=${encodeURIComponent(fileSearchQuery.trim())}`);
    }

    // folder name query
    if (fileInFolderQuery && fileInFolderQuery.trim().length > 1) {
      additionalParams.push(`in_folder=${encodeURIComponent(fileInFolderQuery.trim())}`);
    }

    // How to order the results
    if (sortByQuery && sortByQuery.trim().length > 1) {
      additionalParams.push(`sort_by=${encodeURIComponent(sortByQuery.trim())}`);
    }

    // Limit the result to the first n items
    if (getFirstQuery && getFirstQuery.trim().length > 0) {
      additionalParams.push(`get_first=${encodeURIComponent(getFirstQuery.trim())}`);
    }
    if (skip) {
      additionalParams.push(`skip=${skip}`);
    }

    // Limit the results to the ones with/without folder
    if (hasFolder !== undefined) {
      additionalParams.push(`has_folder=${encodeURIComponent(hasFolder.trim())}`);
    }

    if (filterTags !== undefined && filterTags !== null) {
      additionalParams.push(`filter_tags=${encodeURIComponent(filterTags.join(','))}`);
    }

    if (processTagFilter !== undefined) {
      additionalParams.push(`process_tag=${processTagFilter}`);
    }

    if (aggregateBy) {
      additionalParams.push(`aggregate_by=${aggregateBy}`);
    }

    if (filterScribes) {
      additionalParams.push(`filter_scribes=${encodeURIComponent(filterScribes)}`);
    }

    return fetcher('scribe_file/' + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`, 'GET', authenticated);
  },
  listWorkspace: async ({ fileSearchQuery, parentFolderId, skip, get_first, filterTags, filterScribes }) => {
    const additionalParams = [];
    // file name query

    if (fileSearchQuery && fileSearchQuery.trim().length > 1) {
      additionalParams.push(`q=${encodeURIComponent(fileSearchQuery.trim())}`);
    }

    // parent folder id query
    if (!!parentFolderId && parentFolderId.trim().length > 1) {
      additionalParams.push(`in_folder=${encodeURIComponent(parentFolderId.trim())}`);
    } else if (parentFolderId === null) {
      additionalParams.push(`in_folder=${encodeURIComponent(parentFolderId)}`);
    }

    if (skip !== undefined && skip !== null) {
      additionalParams.push(`skip=${encodeURIComponent(skip)}`);
    }

    if (get_first !== undefined && get_first !== null) {
      additionalParams.push(`get_first=${encodeURIComponent(get_first)}`);
    }
    if (filterTags !== undefined && filterTags !== null && filterTags.length) {
      additionalParams.push(`filter_tags=${encodeURIComponent(filterTags.join(','))}`);
    }
    if (filterScribes !== undefined && filterScribes !== null) {
      additionalParams.push(`filter_scribes=${encodeURIComponent(filterScribes)}`);
    }

    return fetcher('scribe_file/' + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`, 'GET', true);
  },
  duplicateScribeDocument: async (id, orgId) => fetcher(`scribe_documents/${id}/duplicate`, 'POST', true, { organization_id: orgId }),
  retryDuplicateScribeDocument: async (id) => fetcher(`scribe_documents/${id}/retry_duplicate`, 'POST', true),
  changeFolderOrder: async (id, newOrder, newFolderId) => {
    const body = {
      folder_sort_order: newOrder,
      folder_id: newFolderId
    };

    return fetcher(`scribe_file/${id}/`, 'PATCH', true, body);
  },
  exportScribeDocument: async (id, format) => fetcher(`scribe_documents/${id}/export/?as=${format}`, 'GET', true),
  countScribes: async () => fetcher(`scribe_documents/count/`, 'GET', true),
  postScribe: async (body) => fetcher('scribe_file/', 'POST', true, body),
  listSimplifiedActions: async (id) => fetcher(`scribe_documents/${id}/sorted_actions_limited_data`, 'GET', true),
  listActions: async (id) => fetcher(`scribe_documents/${id}/actions`, 'GET', true),
  getScreenshotsPublicStatus: async (id) => fetcher(`scribe_documents/${id}/get_screenshots_public_status`, 'GET', true)
};

export default scribeDocumentService;
